export class PreviewLoadingError extends Error {
    constructor(message?: string) {
        super(message || defaultErrorMessage);
    }
}

const defaultErrorMessage = "Error loading preview. Make sure file is correct.";
